/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
/* eslint-disable comma-dangle */
/* eslint-disable linebreak-style */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axios from 'axios';

import './LoginForm.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import { TITLE_ID } from '../../Constants';
import { gaEvents } from '../../util/events';

function LoginForm(props) {
  const {
    isShowLogin,
    onLoginSuccess, // callback function here for what to call when the user logs in successfully
    onCloseLoginModal,
    setPlayerVerified,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const navigate = useNavigate();

  useEffect(() => {
    if (isShowLogin) {
      setShowModal(true);
    }
  });

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/userPage');
    }
  }, [isLoggedIn]);

  function updatePasswordType(type) {
    setPasswordType(type);
  }

  function handleCloseModal() {
    setShowModal(false);
    onCloseLoginModal();
  }

  function handleSubmitLogin() {
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/Client/LoginWithEmailAddress?sdk=PostmanCollection-0.125.210628`,
        {
          TitleId: TITLE_ID,
          Email: email, // johnx111
          Password: password,
          InfoRequestParameters: {
            GetPlayerProfile: true,
            GetUserVirtualCurrency: true,
            GetUserInventory: true,
            ProfileConstraints: {
              ShowDisplayName: true,
            },
          },
        },
      )
      .then((loginResponse) => {
        const loginResponseData = loginResponse.data.data;
        const playfabID = loginResponseData.PlayFabId;
        gaEvents.clickedLogin();
        window.sessionStorage.setItem('username', loginResponseData.InfoResultPayload.PlayerProfile.DisplayName);
        window.sessionStorage.setItem('entity_token', loginResponseData.EntityToken.EntityToken);
        window.sessionStorage.setItem('session_ticket', loginResponseData.SessionTicket);
        window.sessionStorage.setItem('playfab_id', playfabID);

        axios
          .post(
            `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
            {
              FunctionName: 'LookupPlayerProfile',
              FunctionParameter: {
                TitlePlayerId: null,
                IncludeRoleAndLoadout: true,
                IncludeTopGear: true,
                IncludeAssets: true,
                IncludeBasicStatistics: true,
              },
            },
            {
              headers: {
                'X-EntityToken': window.sessionStorage.getItem('entity_token'),
              },
            },
          ).then((lookupPlayerProfileResponse) => {
            const shinamiWallet = lookupPlayerProfileResponse.data.data.FunctionResult.result.assets.shinamiCustodialWalletAddress;
            window.sessionStorage.setItem('shinami_wallet', shinamiWallet);
            console.log('debug (shinami wallet): ', shinamiWallet);
          });

        axios
          .post(
            `https://${TITLE_ID}.playfabapi.com/Client/GetPlayerProfile`,
            {
              PlayFabId: playfabID,
              ProfileConstraints: {
                ShowDisplayName: true,
                ShowCreated: true,
                ShowLastLogin: true,
                ShowTags: true,
                ShowContactEmailAddresses: true
              }
            },
            {
              headers: {
                'X-Authorization': window.sessionStorage.getItem('session_ticket'),
              },
            },
          ).then((getPlayerProfileResponse) => {
            const addresses = getPlayerProfileResponse.data.data.PlayerProfile.ContactEmailAddresses;
            addresses.forEach((emailInfo) => {
              if (emailInfo.VerificationStatus.includes('Confirmed')) {
                window.sessionStorage.setItem('player_verified', true);
                setPlayerVerified(true);
              }
            });

            setShowModal(false);
            onLoginSuccess();
          });

        navigate('/userPage');
      })

      .catch(() => {
        toast.error(
          'Error logging in! Make sure that this account already exists in Run Legends',
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          },
        );
      });
  }

  const eyeIcon = passwordType === 'password' ? <AiFillEye onClick={() => updatePasswordType('text')} className="eye-icon" /> : <AiFillEyeInvisible onClick={() => updatePasswordType('password')} className="eye-icon" />;

  return (
    <Modal
      ariaHideApp={false}
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      contentLabel="Minimal Modal Example"
      className="mymodal"
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="login-form">
        {/* <h1>LOGIN</h1> */}
        <h1>Welcome Back, Runnegade</h1>
        <h2>Enter your email and password to log in</h2>
        <a className="faq-link" href="https://www.talofagames.com/faq/newplayer"><h2>Need an account? Read the FAQ here</h2></a>
        <form>

          <div className="username">
            <h2>Email</h2>
            <input
              type="text"
              name="email"
              placeholder="bob123"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control input-md"
              autoComplete="on"
            />
          </div>
          <div className="password">
            <h2>Password</h2>
            <div className="password-container">
              <input
                type={passwordType}
                name="email"
                placeholder="bob123"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control input-md"
                autoComplete="on"
              />
              {eyeIcon}
            </div>
          </div>
        </form>

        <button
          className="button"
          onClick={handleSubmitLogin}
        >
          SUBMIT
        </button>
      </div>
    </Modal>
  );
}

LoginForm.propTypes = {
  isShowLogin: PropTypes.bool.isRequired,
  onLoginSuccess: PropTypes.func.isRequired,
  onCloseLoginModal: PropTypes.func.isRequired,
};

export default LoginForm;
